var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { "min-height": "320px" } },
    [
      _c("Subheader", {
        attrs: { dense: "", title: "Add Filters", "no-search": "" },
      }),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c(
          "div",
          { attrs: { id: "nav-layout" } },
          [
            _c(
              "v-layout",
              { attrs: { wrap: "", "fill-height": "" } },
              [
                _c(
                  "v-window",
                  {
                    model: {
                      value: _vm.window,
                      callback: function ($$v) {
                        _vm.window = $$v
                      },
                      expression: "window",
                    },
                  },
                  [
                    _c(
                      "v-window-item",
                      { attrs: { value: 0 } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            box: "",
                            label: "Search file name",
                            hint: "Press `enter` or the icon to search",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.emitSearch.apply(null, arguments)
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "no-transition-delay",
                                      attrs: {
                                        icon: "",
                                        left: "",
                                        color: _vm.fileNameInput ? "info" : "",
                                      },
                                      on: { click: _vm.emitSearch },
                                    },
                                    [_c("v-icon", [_vm._v("search")])],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.fileNameInput,
                            callback: function ($$v) {
                              _vm.fileNameInput = $$v
                            },
                            expression: "fileNameInput",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "px-2" },
                          _vm._l(_vm.buttonList, function (button, index) {
                            return _c(
                              "v-btn",
                              {
                                key: button.key,
                                attrs: { depressed: "", block: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleTo(index + 1)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(button.label))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.buttonList, function (button, index) {
                      return _c(
                        "v-window-item",
                        { key: index + 1, attrs: { value: index + 1 } },
                        [
                          _c(
                            "v-toolbar",
                            { attrs: { dense: "", flat: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleTo(0)
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("keyboard_arrow_left")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-toolbar-title", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(button.label) +
                                    "\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "keep-alive",
                            [
                              _c(button.component, {
                                ref: "nav-content",
                                refInFor: true,
                                tag: "component",
                                staticClass: "pa-2",
                                on: {
                                  returnEvent: function ($event) {
                                    return _vm.handleUpdate($event)
                                  },
                                  instantSearchEvent: function ($event) {
                                    return _vm.handleUpdateWithoutToggle($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }